<script lang="ts">
  import { tooltip } from "@kontextwerk/web-sdk/core/overlay/tooltip"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../_shared/_logic/rich-tooltips"
  import {
    daySummaryPresentation,
    type CalendarDaySummary,
  } from "../../../../../_logic/day-summary"

  let { summary }: { summary?: CalendarDaySummary | null } = $props()
  const detailsId = $props.id()
  const presentation = $derived(summary ? daySummaryPresentation(summary) : null)

  function openFromKeyboard(event: KeyboardEvent) {
    if (event.key !== "Enter" && event.key !== " ") return

    event.preventDefault()
    event.stopPropagation()
    const button = event.currentTarget as HTMLButtonElement
    const rect = button.getBoundingClientRect()
    // The shared tooltip positions at the activation point, including keyboard activation.
    button.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        clientX: rect.left + rect.width / 2,
        clientY: rect.bottom,
      }),
    )
  }
</script>

{#if presentation}
  <button
    type="button"
    class="day-summary"
    aria-label={`Tagesbilanz: ${presentation.label}. Terminlast und Wege, Details anzeigen`}
    aria-describedby={detailsId}
    onkeydown={openFromKeyboard}
    use:tooltip={{ when: "click", content: presentation.tooltip, className: RICH_TOOLTIP_CLASS }}
  >
    {#if summary && (summary.knownRoutes || summary.unknownRoutes)}
      <span class={`route-dot ${presentation.grade.toLowerCase()}`} aria-hidden="true"></span>
    {/if}
    <span class="summary-label">{presentation.label}</span>
  </button>
  <span id={detailsId} hidden>{presentation.tooltip.replace(/<[^>]+>/g, " ")}</span>
{/if}

<style>
  .day-summary {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    max-width: 100%;
    min-width: 0;
    padding: 2px 0;
    margin: 0;
    border: 0;
    background: transparent;
    color: var(--cal-text-muted, #617481);
    font: inherit;
    font-size: 11px;
    line-height: 16px;
    text-align: left;
    cursor: pointer;
  }
  .day-summary:hover {
    color: var(--cal-text, #2f4858);
  }
  .day-summary:focus-visible {
    outline: 2px solid var(--cal-text, #2f4858);
    outline-offset: 2px;
  }
  .summary-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: inherit;
  }
  .route-dot {
    width: 6px;
    height: 6px;
    flex: 0 0 6px;
    border-radius: 50%;
    background: #7c8c95;
  }
  .route-dot.green {
    background: var(--success-100, #0f8f4d);
  }
  .route-dot.yellow {
    background: var(--warning-100, #d49a24);
  }
  .route-dot.red {
    background: var(--error-100, #c63c42);
  }
</style>
